import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class ExpiryCheckQualifier {
    phase = CouponApplyPhase.PreApply;
    _data;
    _dependencies;
    constructor(dependencies, sourceData) {
        this._data = sourceData;
        this._dependencies = dependencies;
    }
    // Judged against the order's date (future date if set), not today.
    _isOutsideDateRange(coupon, cart) {
        if (coupon.startDate == null && coupon.expiryDate == null)
            return false;
        const orderDate = this._toDateOnly(this._getOrderDate(cart));
        const isBeforeStart = coupon.startDate != null && orderDate < this._toDateOnly(coupon.startDate);
        const isAfterExpiry = coupon.expiryDate != null && orderDate > this._toDateOnly(coupon.expiryDate);
        return isBeforeStart || isAfterExpiry;
    }
    // A non-future order before the business-day start belongs to the previous business day.
    _getOrderDate(cart) {
        if (cart.futureDate)
            return cart.futureDate;
        const now = this._data.tempNow ?? this._dependencies.nowStore(this._data.timeOffset);
        return this._dependencies.getBusDate(now, this._data.timeOffset, this._data.settings.BSM);
    }
    _toDateOnly(date) {
        return new Date(date).setHours(0, 0, 0, 0);
    }
    _checkSchedule(schedules, cart) {
        let promiseDate;
        let dayOfWeek = 0;
        let promiseMinutes = 0;
        if (cart.futureDate && cart.futureMinute != null) {
            promiseDate = new Date(cart.futureDate);
            dayOfWeek = promiseDate.getDay();
            promiseMinutes = cart.futureMinute;
        }
        else {
            promiseDate = this._data.tempNow ?? this._dependencies.nowStore(this._data.timeOffset);
            const promiseBDate = new Date(this._dependencies.getBusDate(promiseDate, this._data.timeOffset, this._data.settings.BSM));
            dayOfWeek = promiseBDate.getDay();
            promiseMinutes = promiseDate.getMinutes() + (60 * promiseDate.getHours());
        }
        return schedules.some(schedule => {
            return schedule.weekDayNumber === dayOfWeek && schedule.isActive && schedule.startDayMinute <= promiseMinutes && schedule.endDayMinute >= promiseMinutes;
        });
    }
    qualify(coupon, cart) {
        if (this._isOutsideDateRange(coupon, cart)) {
            return { isValid: false, errorCode: CouponApplyErrorCode.NOT_VALID_TODAY };
        }
        if (coupon.schedules.length > 0) {
            const result = this._checkSchedule(coupon.schedules, cart);
            if (!result) {
                return { isValid: false, errorCode: CouponApplyErrorCode.NOT_VALID_TODAY };
            }
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=expiry-check.js.map